<div class="flex flex-col h-full w-full">
  <!-- Overlay for modal -->
  @if (visible) {
    <div
      class="fixed inset-0 bg-black/[0.32] dark:bg-black/60 h-screen w-screen z-[60]"
    ></div>
  }

  <!-- Main modal -->
  <div
    [style.display]="visible ? 'flex' : 'none'"
    tabindex="-1"
    class="fixed inset-0 z-[70] flex justify-center items-center overflow-y-auto"
  >
    <!-- Modal content -->
    <div class="max-w-6xl bg-white rounded-2xl shadow-2xl dark:bg-gray-900">
      <!-- Modal header -->
      <div
        class="flex items-center justify-between p-1 md:p-1 rounded-t dark:border-gray-600"
      >
        <button
          type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          (click)="closeModal()"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <section class="bg-white dark:bg-gray-900">
        <div class="px-4 mx-auto max-w-5xl">
          <!-- Title, update or claim field -->
          <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white">
            {{ fieldName }}
          </h2>
          <form>
            <!-- Grower Name, Grower Email, Total Target Water -->
            <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
              <!-- Grower Name -->
              <div class="col-span-4 w-full">
                <label
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Grower Name</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 left-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="userName"
                  />
                </div>
              </div>
              <!-- Grower Email -->
              <div class="col-span-3 w-full">
                <label
                  for="irrigation_methods_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Email</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z"
                      />
                      <path
                        d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="email"
                  />
                </div>
              </div>
              <!-- Total Target Water -->
              <div class="col-span-2 w-full mb-3">
                <label
                  for="total_target_water"
                  class="flex items-center gap-1 mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Target Water
                  <app-info-popover
                    class="ml-1 pb-1"
                    [infoType]="'totalTargetWater'"
                  ></app-info-popover
                ></label>
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="totalTargetWater"
                  />
                </div>
              </div>
              <!-- Deficit Irrigation -->
              <div class="col-span-2 w-full mb-3">
                <label
                  for="is_deficit_irrigation"
                  class="flex items-center gap-1 mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Deficit Irrigation
                  <app-graph-popover-instruction
                    [infoType]="'deficitIrrigation'"
                /></label>
                <input
                  type="text"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="is_deficit_irrigation"
                />
              </div>
            </div>
            <!-- Entity Name and Email and Is Shared -->
            <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-3">
              <!-- Entities -->
              <div class="col-span-11 w-full">
                <label
                  class="flex items-center gap-1 mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Entities
                  <app-graph-popover-instruction [infoType]="'entityName'"
                /></label>
                <div
                  class="bg-gray-50 border border-gray-300 rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 min-h-[42px] max-h-32 overflow-y-auto"
                >
                  @if (entities.length === 0) {
                    <span
                      class="text-sm text-gray-500 dark:text-gray-400 italic"
                      >None</span
                    >
                  } @else {
                    <div class="flex flex-wrap gap-2">
                      @for (entry of entities; track entry.email) {
                        <span
                          class="inline-flex items-center gap-1 px-2 py-1 text-xs 2xl:text-sm font-medium text-blue-800 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-200"
                        >
                          {{ entry.name }} {{ "{" + entry.email + "}" }}
                        </span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- Crop Group 01-->
            <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-3">
              <!-- Crop Types 01 -->
              <div class="col-span-4 w-full">
                <div class="flex flex-row items-center gap-1 mb-2">
                  <label
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >Crop 1</label
                  >
                  <app-graph-popover-instruction
                    [infoType]="'coverCrop'"
                    [placement]="'right'"
                  />
                </div>
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="crop_type_01"
                />
              </div>
              <!-- Irrigation Methods 01 -->
              <div class="col-span-3 w-full">
                <label
                  for="irrigation_methods_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >{{ irrigationDropdownLabel }}</label
                >
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="irrigation_methods_01"
                />
              </div>
              <!-- Start 01 -->
              <div class="col-span-2 w-full mb-3">
                <label
                  for="ls_start_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Start Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_start_01"
                  />
                </div>
              </div>
              <!-- End 01-->
              <div class="col-span-2 w-full">
                <label
                  for="ls_end_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >End Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_end_01"
                  />
                </div>
              </div>
            </div>
            <!-- Crop Group 02-->
            <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-3">
              <!-- Crop Types 02 -->
              <div class="col-span-4 w-full">
                <label
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Crop 2</label
                >
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="crop_type_02"
                />
              </div>
              <!-- Irrigation Methods 02 -->
              <div class="col-span-3 w-full">
                <label
                  for="irrigation_methods_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >{{ irrigationDropdownLabel }}</label
                >
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="irrigation_methods_02"
                />
              </div>
              <!-- Start 02 -->
              <div class="col-span-2 w-full mb-3">
                <label
                  for="ls_start_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Start Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_start_02"
                  />
                </div>
              </div>
              <!-- End 02-->
              <div class="col-span-2 w-full">
                <label
                  for="ls_end_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >End Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_end_02"
                  />
                </div>
              </div>
            </div>
            <!-- Crop Group 03-->
            <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-3 mb-3">
              <!-- Crop Types 03 -->
              <div class="col-span-4 w-full">
                <label
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Crop 3</label
                >
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="crop_type_03"
                />
              </div>
              <!-- Irrigation Methods 03 -->
              <div class="col-span-3 w-full">
                <label
                  for="irrigation_methods_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >{{ irrigationDropdownLabel }}</label
                >
                <input
                  type="text"
                  name="fieldName"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                  readonly
                  [value]="irrigation_methods_03"
                />
              </div>
              <!-- Start 03 -->
              <div class="col-span-2 w-full mb-3">
                <label
                  for="ls_start_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Start Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_start_03"
                  />
                </div>
              </div>
              <!-- End 03-->
              <div class="col-span-2 w-full">
                <label
                  for="ls_end_03"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >End Date</label
                >
                <div class="relative max-w-sm">
                  <div
                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                  >
                    <svg
                      class="w-4 h-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="fieldName"
                    class="pl-10 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-primary-500 pointer-events-none focus:outline-none focus:ring-0"
                    readonly
                    [value]="ls_end_03"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      <!-- Modal footer -->
      <div
        class="flex items-center py-2 md:py-2 space-x-3 rtl:space-x-reverse border-gray-200 rounded-b dark:border-gray-900"
      ></div>
    </div>
  </div>
</div>
